import { Fragment } from "react";
import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';

interface JsonDivProps {
    data: any;
}
export default function JsonDiv({ data }: JsonDivProps) {
    return (
        <Fragment>
            {
                <div>
                    {
                        Object.entries(data).map(([key, value]) => (
                            <div className="d-flex bg-white fs-12" key={key}>
                                <JsonView data={{ [key]: value }} style={{ ...defaultStyles, container: "background:white" }} shouldExpandNode={allExpanded} />
                            </div>
                        ))
                    }
                </div>
            }
        </Fragment>
    );
}


